import { WabaProvider } from "../data/whatsapp/waba-provider";

export interface WabaUpdateRequestModel {
  wabaEmail: string;
  wabaPassword: string | null;
  wabaId: string | null;
  wabaGuid: string;
  wabaName: string | null;
  wabaPhone: string | null;
  wabaPhoneId: string | null;
  wabaToken?: string | null;
  wabaProvider: WabaProvider;

  wabaMetaEmail?: string | null;
  wabaMetaPassword?: string | null;
  wabaMetaGuid?: string | null;
  wabaMetaToken?: string | null;
  wabaMetaId?: string | null;
  wabaMetaPhone?: string | null;
  wabaMetaPhoneId?: string | null;

  wabaFireMobileEmail?: string | null;
  wabaFireMobilePassword?: string | null;
  wabaFireMobileGuid?: string | null;
  wabaFireMobileToken?: string | null;
  wabaFireMobilePhone?: string | null;
  wabaFireMobilePhoneId?: string | null;

  wabaNubitelEmail?: string | null;
  wabaNubitelPassword?: string | null;
  wabaNubitelGuid?: string | null;
  wabaNubitelToken?: string | null;
  wabaNubitelPhone?: string | null;
  wabaNubitelPhoneId?: string | null;
}
